import React from 'react';
import './FullView.css';
import {config} from "../../../config";

// @ts-ignore
function FullView({ visible, cardId, setVisibleFullView}) {

    const rootClasses = ['researchFullViewContainer'];


    if (visible) {
        rootClasses.push('researchFullViewContainerActive');
    }
    return (
        <div className={rootClasses.join(' ')} onClick={()=>{setVisibleFullView(false)}} >

            <img  src={config.cdnUrl + "/img/cards/max/" + cardId + ".webp"} className='cardFullView' />
        </div>
    );
}

export default FullView;